export const NAMESPACE = 'trainer';
export const TRAINER_BASE = `${NAMESPACE}/TRAINER_BASE`;
export const GET_TRAINER = `${NAMESPACE}/GET_TRAINER`;
export const SET_TRAINER = `${NAMESPACE}/SET_TRAINER`;
export const SET_TRAINER_GENERIC = `${NAMESPACE}/SET_TRAINER_GENERIC`;
export const FINISHED_RETRIEVING = `${NAMESPACE}/FINISHED_RETRIEVING`;
